export const enviarcheckin = {
    text1: "Enviar Check-In",
    text2: "Envie um link para que seus hóspedes façam o check-in antes de chegar à acomodação.",
    text3: "Selecione a acomodação *",
    text4: "Digite o nome",
    text5: "Nome do hóspede *",
    text6: "Número de telefone do hóspede *",
    text7: "E-mail",
    text8: "E-mail do hóspede *",
    text9: "Enviar",
    text09: "Agendar",
    text10: "Enviando o check-in, aguarde",
    text11: "Você precisa selecionar uma acomodação para atribuir o check-in",
    text12: "O campo nome é obrigatório",
    text13: "O campo telefone é obrigatório",
    text14: "O e-mail é obrigatório",
    text15: "Quase lá",
    text16: "Olá ",
    text17: "! Somos ",
    text18: ". Enviamos esta mensagem para que você possa fazer o check-in antes de chegar à nossa acomodação, evitando possíveis esperas na recepção e, acima de tudo, o consumo desnecessário de papel. \n\nPor um planeta mais verde!",
    text19: "Olá ",
    text20: "! Somos ",
    text21: ". Enviamos esta mensagem para que você possa fazer o check-in antes de chegar à nossa acomodação, evitando possíveis esperas na recepção e, acima de tudo, o consumo desnecessário de papel. <br> <br> Por um planeta mais verde!",
    text22: "Check-in enviado com sucesso",
    text23: "Carregando ...",

    // Corrections
    p1: "Enviar link de check-in",
    p2: "Criar reserva",
    p3: "Informações da reserva",
    p4: "Nome do hóspede responsável",
    p5: "Data do check-in",
    p6: "Data do check-out",
    p7: "Número de hóspedes",
    p8: "Selecione um quarto",
    p9: "Não especificado",
    p10: "Selecione o número do quarto",
    p11: "Check-in online",
    p12: "Preço da reserva",
    p13: "Criar reserva",
    p14:`Agora convide seu hóspede a prosseguir com o check-in.`,
    p15:`Cobrança adicional`,

    p16:`Especifique o quarto`,
    p17:`Se você selecionar um quarto, enviaremos as chaves associadas`,
    p18:`Selecionar quarto`,
    p19:`Nenhum resultado encontrado. Tente outro termo.`,
    p20:`Nenhum quarto disponível.`,
    p21:`Pressione enter para selecionar`,
    p22:`Selecionado`,
    p23:`Pressione enter para remover`,
    p24:`Nenhuma opção disponível`,
    p25: `Reserva criada com sucesso.`,
    p26: `A reserva foi concluída com sucesso. Você pode voltar à página inicial.`,
    p27: `Convite enviado com sucesso.`,
    p28: `Aceitar`,
};
